import Model from "../../classes/model/Model";
import qs from "qs";

/**
 * @property {int} id
 * @property {int} old_id
 * @property {int} company_id
 * @property {int} filiation_id
 * @property {string} email
 * @property {string} login
 * @property {string} name
 * @property {string} last_name
 * @property {string} image
 * @property {int} birthday
 * @property {string} phone
 * @property {string} comment
 *
 * @property {int} created_by
 * @property {int} updated_by
 * @property {int} created_at
 * @property {int} updated_at
 *
 * @property {User} creator
 * @property {User} updater
 */
export default class User extends Model {

    get fullName() {
        let pieces = [];
        if (this.name) {
            pieces.push(this.name);
        }
        if (this.last_name) {
            pieces.push(this.last_name);
        }
        return pieces.join(' ');
    }

    relations() {
        return {
            creator: {class: User, many: false},
            updater: {class: User, many: false},
        };
    }

    static getList(filter = {}, page = 1, sort = undefined, perPage = 25,  extraFields = []) {

        return User.getAxios().get(User.getUrl('user/list'), {
            params: {
                page: page,
                'per-page': perPage,
                filter: filter,
                sort: sort,
                expand: extraFields.length > 0 ? extraFields.join(',') : undefined,
            },
            paramsSerializer: params => qs.stringify(params),
        }).then((response) => {
            let data = [];
            for (let bid of response.data) {
                data.push(new User(bid));
            }
            return {data, headers: response.headers};
        });
    }

}
